export default __webpack_public_path__ + "static/media/3-warranty.de089848.svg";